// @ts-nocheck
import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useMst } from "../../mobx";
import { Grid } from "@mui/material";
import QuestionForm from "../../modules/QuestionForm/QuestionForm";
import { observer } from "mobx-react-lite";
import * as dcopy from "deepcopy";

export default observer(function QuestionEdit() {
	const { id } = useParams<{ id: string }>();
	const [questionLoad, setQuestionLoad] = useState(false);
	const [loading, setLoading] = useState(false);
	const { questionsStore } = useMst();
	const { getQuestion, getQuestionData, updateQuestion } = questionsStore;

	useEffect(() => {
		async function getQuestionAsync() {
			setQuestionLoad(true);
			await getQuestion(id);
			setQuestionLoad(false);
		}
		getQuestionAsync();
	}, [id]);

	const handleUpdate = async (data: any) => {
		setLoading(true);
		await updateQuestion(data);
		setLoading(false);
	};

	return (
		<Grid container direction={"column"} sx={{ width: "100%" }}>
			{questionLoad ? null : (
				<QuestionForm
					loading={loading}
					onSubmit={handleUpdate}
					defaultQuestion={dcopy(getQuestionData(id)?.toJSON())}
				/>
			)}
		</Grid>
	);
});
